module.exports = __webpack_public_path__ + "34e13c020df1e41d4e80a57c22cd3be4.jpg";